import { lazy } from 'react';

// dynamic-import -- the doc-reader bundle pulls in pdfjs-dist and only loads once a document opens.
export const LazyDocReaderProvider = lazy(() =>
  import('@/lib/doc-reader').then((m) => ({ default: m.DocReaderProvider })),
);
// dynamic-import -- the document view is part of the lazy pdfjs-dist reader chunk.
export const LazyDocumentView = lazy(() =>
  import('@/lib/doc-reader/document/doc-tanstack').then((m) => ({
    default: m.DocViewTanStack,
  })),
);
// dynamic-import -- the reader view is part of the lazy pdfjs-dist reader chunk.
export const LazyReaderView = lazy(() =>
  import('@/lib/doc-reader/reader/reader-tanstack').then((m) => ({
    default: m.ReaderViewTanStack,
  })),
);
// dynamic-import -- the doc-pack reader view is part of the lazy pdfjs-dist reader chunk.
export const LazyDocPackReaderView = lazy(() =>
  import('@/lib/doc-reader/reader/doc-pack-reader-tanstack').then((m) => ({
    default: m.DocPackReaderViewTanStack,
  })),
);
